import { getScholarListApi } from "@/api/talent";

export const scholarSearchMixin = {
  data() {
    return {
      showMoreContent: true,
      loading: false,
      recommendData: [
        {
          type: '1',
          typeText: '专家查询',
          question: '查询北京大学从事人工智能研究的学者有哪些？',
        },
        {
          type: '1',
          typeText: '专家查询',
          question:
            '查询Brown University的Roberto Tamassia老师和企业合作的论文有哪些？',
        },
      ],
      pager: {
        pageNumber: 1,
        pageSize: 20,
      },
      total: 0,
      talentLocationValue: '全部', // 默认国内人才
      talentParams: {
        searchType: 'common', // 检索类型: common -- 默认值  high-level --- 精准检索
        matchPub: false, // 关键词 是否匹配成果
        is1: false, //选中产业
        is2: true, //选中领域
        is3: false, //选中更多
        text: '', // 关键词-搜索词
        oneDomainId: '', // 一级产业
        twoDomainId: '', // 二级产业
        thirdDomainId: '', // 三级产业
        oneFieldNames: '', // 一级领域
        twoFieldNames: '', // 二级领域
        scholarType: '', //人才类型
        countryType: '', // 国家/地区
        province: '', //省
        city: '', //市
        district: [], //区
        majorTeams: '', //重大团队
        pubCount: [], //成果数
        servingInTheStudentAssociation: [], //学协会任职
        enterpriseTalent: [], //企业人才
        nativeProvince: [], //籍贯-省
        nativeCity: [], //籍贯-市
        nativeDistrict: [], //籍贯-区
        position: [],
        country: [], //国家(国外)
        base: [], //所属基地(国外)
        ranking: [], //机构排名(国外)
        honoraryTitle: ['国家级人才计划','院士','省杰青','省优青'], //荣誉称号(国外)
        awards: [], //奖项(国外)
        awardType: [], // 奖项
        title: '', // 职称
        education: '', // 学历
        age: '', //年龄段
        workYear: '', // 工作年限
        sort: '', //排序
        qingnian: false, //海外青年人才
        shenHongKong: false, //深港合作人才
        hasContact: false, //是否有联系方式
        type: 'field',
        graduateValue: '', // 毕业院校
      },

      talentData: [],
    };
  },
  created() {
    this.getRecommendList();
  },
  methods: {
    // 点击推荐的问题
    handleClickRecommend(item) {
      // console.log(item);
      this.$refs.textAreaRef.searchValue = item.question;
    },

    // 为你推荐
    getRecommendList() {
      this.loading = true;
      let pa = {
        ...this.talentParams,
        ...this.pager
      }
      getScholarListApi(pa).then(res => {
        res.data.records.map(item => {
          item['follow'] = false;
        })
        this.loading = false;
        this.talentData = res.data.records;
      }).finally(() => {
        this.loading = false;
      })
    },
  },
  watch: {
    $route: {
      handler() {
        this.getRecommendList();
      },
      // immediate: true,
    },
  }
};
